import { QueryFunctionContext } from '@tanstack/react-query';

import { GET_WITH_CREDENTIALS } from '~/api';
import { JiraIssueTypeStatusByNameApiUrl } from '~/api/urls';
import { IJiraStatus } from '~/domain/IJiraStatus';

export const getStatuses = async (context: QueryFunctionContext<[string, { typeName: string }]>): Promise<IJiraStatus[]> => {
  const typeName = context.queryKey[1].typeName;
  const url = JiraIssueTypeStatusByNameApiUrl.expand({
    typeName,
  });
  
  return await GET_WITH_CREDENTIALS<IJiraStatus[]>(url) || [];
}
